import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { AppConfig } from 'common';

@Component({
  selector: 'tyt-social-buttons',
  templateUrl: './social-buttons.component.html',
  styleUrls: ['./social-buttons.component.scss']
})
export class SocialButtonsComponent implements OnInit {

    
  private _url: string;
  constructor(
    private appConfig : AppConfig
    //   private elementRef : ElementRef
  ) { }

  @Input()
  follow: boolean = false;

  @Input()
  public get url(): string {
    return this._url;
  }

  @Input()
  title: string;

  @Input()
  description: string;

  @Input()
  imageUrl: string;

  public set url(value) {
    if (value.startsWith('/')) {
      value = `${this.appConfig.appUrl}${value}`;
    }

    this._url = value;
    this.update();
  } 
  
  ngOnInit() {
      this.update();
  }

  update() {
      if (typeof window !== 'undefined') {
        //   this.elementRef.nativeElement.innerHTML = '';
        
        //   let element = document.createElement('a');
        //   element.classList.add('addthis_inline_share_toolbox');

        //   if (this._url) {
        //       element.setAttribute('data-url', this._url);
        //   }

        // (this.elementRef.nativeElement as HTMLElement).appendChild(element);

        setTimeout(() => {
            if (window['addthis'] && window['addthis'].layers && window['addthis'].layers.refresh) {
              window['addthis'].layers.refresh();
            }
        }, 250);
      }
  }

}
